import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import DeleteAccount from './pages/DeleteAccount';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { PrivateRoute } from './components/PrivateRoute';
import NavigationBar from './components/NavigationBar';
import styled from 'styled-components';
import { AuthProvider } from './components/AuthContext';

const Content = styled.div`
  padding-top: 80px; /* Height of the nav bar */
  padding-bottom: 60px; /* Height of the footer */
`;

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
  border-top: 1px solid #ddd;
  background-color: #f0f2f5;
`;

const FooterLink = styled.a`
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <NavigationBar />
        <Content>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/delete-account"
              element={
                <PrivateRoute>
                  <DeleteAccount />
                </PrivateRoute>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </Content>
        <Footer>
          <p>&copy; AUNE 2024 | <FooterLink href="/privacy-policy">Paramètres de Confidentialité</FooterLink></p>
        </Footer>
      </Router>
    </AuthProvider>
  );
};

export default App;
